import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function CapacitiesPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="ความจุ"
            apiPath="/capacities"
            fieldKey="size"      
            createDefaultValue="รายการใหม่" 
            initialItems={[]}
        />
    );
}
